if (!customElements.get('accordion-disclosure')) {
  customElements.define(
    'accordion-disclosure',
    class AccordionDisclosure extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.contentWrapper = this.querySelector('.accordion__content-wrapper');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      connectedCallback() {
        if (!this.details || !this.summary || !this.contentWrapper) return;

        const group = this.closest('[data-accordion-group]');

        this.summary.addEventListener('click', (event) => {
          event.preventDefault();

          const willOpen = !this.classList.contains('is-open');

          if (group && willOpen) {
            group.querySelectorAll('accordion-disclosure.is-open').forEach((accordion) => {
              if (accordion !== this) accordion.close();
            });
          }

          if (willOpen) {
            this.open();
          } else {
            this.close();
          }
        });

        this.setAttribute('data-accordion-ready', '');

        if (this.details.hasAttribute('open')) {
          this.open(false);
        }
      }

      getContentHeight() {
        const previousMaxHeight = this.contentWrapper.style.maxHeight;
        this.contentWrapper.style.maxHeight = 'none';
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.maxHeight = previousMaxHeight;
        return height;
      }

      open(animate = true) {
        this.classList.remove('is-closing');
        this.classList.add('is-open');
        this.details.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');

        if (!animate || this.prefersReducedMotion) {
          this.contentWrapper.style.maxHeight = 'none';
          return;
        }

        const contentHeight = this.getContentHeight();
        this.contentWrapper.style.maxHeight = '0px';
        this.contentWrapper.offsetHeight;
        this.contentWrapper.style.maxHeight = `${contentHeight}px`;

        const onTransitionEnd = (event) => {
          if (event.target !== this.contentWrapper || event.propertyName !== 'max-height') return;
          if (!this.classList.contains('is-open')) return;
          this.contentWrapper.removeEventListener('transitionend', onTransitionEnd);
          this.contentWrapper.style.maxHeight = 'none';
        };

        this.contentWrapper.addEventListener('transitionend', onTransitionEnd);
      }

      close(animate = true) {
        this.summary.setAttribute('aria-expanded', 'false');

        if (!animate || this.prefersReducedMotion) {
          this.finishClose();
          return;
        }

        const contentHeight = this.getContentHeight();
        this.classList.add('is-closing');
        this.classList.remove('is-open');
        this.contentWrapper.style.maxHeight = `${contentHeight}px`;
        this.contentWrapper.offsetHeight;
        this.contentWrapper.style.maxHeight = '0px';

        const onTransitionEnd = (event) => {
          if (event.target !== this.contentWrapper || event.propertyName !== 'max-height') return;
          this.contentWrapper.removeEventListener('transitionend', onTransitionEnd);
          this.finishClose();
        };

        this.contentWrapper.addEventListener('transitionend', onTransitionEnd);
      }

      finishClose() {
        this.classList.remove('is-closing');
        this.classList.remove('is-open');
        this.details.removeAttribute('open');
        this.contentWrapper.style.maxHeight = '';
      }
    },
  );
}
